import { UI_CONSTANTS } from '@/common/constants/ui.constants'
import { unities } from '@/common/constants/unities.constants'
import { formatCurrency, formatDecimal, formatUnit } from '@/common/utils/formatters'
import { ConsumptionData } from '@/features/failedConsumptions/types/consumption.type'
import { useId } from 'react'
import { Tooltip } from 'react-tooltip'

type FailedConsumptionDetailsProps = {
  data: ConsumptionData
}

export const FailedConsumptionDetails = ({ data: consumption }: FailedConsumptionDetailsProps) => {
  const uniqueId = useId()
  const failureFullMessage = consumption.failure_message || '--'
  const failureMessage =
    failureFullMessage.length > UI_CONSTANTS.TOOLTIP_MESSAGE_TRUNCATE_LENGTH
      ? `${failureFullMessage.slice(0, UI_CONSTANTS.TOOLTIP_MESSAGE_TRUNCATE_LENGTH)}...`
      : failureFullMessage

  return (
    <div className="flex flex-col gap-3">
      {consumption?.establishment_branch?.general_information?.fantasy_name && (
        <div className="flex gap-2 items-center">
          <p className="italic">Estabelecimento:</p>

          <p className="font-bold">{consumption?.establishment_branch?.general_information?.fantasy_name || '--'}</p>
        </div>
      )}

      <div className="flex gap-2 items-center">
        <p className="italic">Mensagem de falha:</p>

        <p
          className="font-bold"
          data-tooltip-id={uniqueId}
          data-tooltip-place="top"
          data-tooltip-html={
            failureFullMessage.length > UI_CONSTANTS.TOOLTIP_MESSAGE_TRUNCATE_LENGTH ? failureFullMessage : undefined
          }
        >
          {failureMessage}
        </p>

        <Tooltip
          id={uniqueId}
          className="z-50 max-w-96 whitespace-pre-wrap break-words bg-black-900 p-4 border border-gray-700 text-white-900 text-sm"
        />
      </div>

      <div className="flex flex-col justify-start">
        {consumption?.line_items.map((line_item) => (
          <p key={line_item.id}>
            {line_item.product.display_name} -{' '}
            {formatUnit(formatDecimal(line_item.quantity, 3), line_item.product.unit_for_quantity)} -{' '}
            {formatCurrency(Number(line_item.amount) / Number(line_item.quantity))} /{' '}
            {unities[line_item.product.unit_for_quantity]}
          </p>
        ))}
      </div>
    </div>
  )
}
